import urljoin from 'url-join';
import {
	API_BASEPATH_PORTAL,
	API_ENDPOINT_PROJECT,
	API_ENDPOINT_SMART_PANELS_CDT,
	API_ENDPOINT_SMART_PANELS_FILE,
	API_ENDPOINT_SMART_PANELS_HEATMAP,
	API_ENDPOINT_SMART_PANELS_RESULTS,
	API_ENDPOINT_SMART_PANELS_SAMPLESETIDS
} from "../config/env.config";
import { callApi, getBlob } from "../middleware/requests";
import sample from "./data/rpdSample.json";
import { DISCOVERY_PREFIX, BIOSTRESS, LIVERFIBROSIS, MICROBIOME, KIDNEYFUNCTION } from "@/enums/Enums";

export const mockApi = {
	call: (mockResponseGenerator, fail = false, timeout = 50) => {
		return new Promise((resolve, reject) => {
			setTimeout(() => {
				if (fail) reject(mockResponseGenerator());
				else resolve(mockResponseGenerator());
			}, timeout);
		});
	},
};

//replace with API_ENDPOINT_SMART_PANELS_SAMPLESET
export const fetchProject = (projectId) =>
	callApi(urljoin(API_ENDPOINT_PROJECT, projectId), true, 'GET');
	
export const fetchSample = (projectId, samplesetId) => mockApi.call(() => sample);

export const fetchSampleSets = async (projectId, productType = MICROBIOME) =>
	callApi(urljoin(API_ENDPOINT_SMART_PANELS_SAMPLESETIDS, `${DISCOVERY_PREFIX}${productType}`, projectId), true, 'GET');

export const fetchAllSampleSets = async (projectId) => {
	let microbiome = [];
	try {
		microbiome = await fetchSampleSets(projectId);
		 
	} catch (e) { console.error(e); }

	let biostress = [];
	try {
		biostress = await fetchSampleSets(projectId, BIOSTRESS);
		 
	} catch (e) { console.error(e); }

	let liverfibrosis = [];
	try {
		liverfibrosis = await fetchSampleSets(projectId, LIVERFIBROSIS);
		 
	} catch (e) { console.error(e); }

	let kidneyfunction = [];
	try {
		kidneyfunction = await fetchSampleSets(projectId, KIDNEYFUNCTION);
		 
	} catch (e) { console.error(e); }

	return {
		[BIOSTRESS]: biostress,
		[MICROBIOME]: microbiome,
		[LIVERFIBROSIS]: liverfibrosis,
		[KIDNEYFUNCTION]: kidneyfunction,
	};
};

export const fetchResults = async (projectId, sampleSetId, productType = MICROBIOME) =>
	callApi(API_ENDPOINT_SMART_PANELS_RESULTS, true, 'POST', {
		"projectId": projectId,
		"sampleSetId": sampleSetId,
		"productType": `${DISCOVERY_PREFIX}${productType}`,
	});
export const fetchMetabolites = async (productType = MICROBIOME) =>
	callApi(API_ENDPOINT_SMART_PANELS_FILE, true, 'POST', {
		"type": "Metabolites",
		"fileVersion": "1.0",
		//"filename": "metabolites.json",
		"productType": `${DISCOVERY_PREFIX}${productType}`
	});
export const fetchPathways = async (productType = MICROBIOME) =>
	callApi(API_ENDPOINT_SMART_PANELS_FILE, true, 'POST', {
		"type": "Pathways",
		"fileVersion": "1.0",
		//"filename": "pathways.json",
		"productType": `${DISCOVERY_PREFIX}${productType}`
	});
export const fetchAssociations = async (productType = MICROBIOME) =>
	callApi(API_ENDPOINT_SMART_PANELS_FILE, true, 'POST', {
		"type": "Associations",
		"fileVersion": "1.0",
		//"filename": "associations.json",
		"productType": `${DISCOVERY_PREFIX}${productType}`
	});

export const fetchAndDownloadCDTData = async (projectId, sampleSetId, productType = MICROBIOME) =>
	getBlob(API_ENDPOINT_SMART_PANELS_CDT, "Data Table.xlsx", 'POST', {
		"projectId": projectId,
		"sampleSetId": sampleSetId,
		"productType": `${DISCOVERY_PREFIX}${productType}`
	});

export const fetchAndDownloadHeatmapData = async (projectId, sampleSetId, productType = MICROBIOME, invertedFoldChange = false, displayExtraMeanPercent = false) =>
	getBlob(API_ENDPOINT_SMART_PANELS_HEATMAP, "Heatmap.xlsx", 'POST', {
		"projectId" : projectId,
		"sampleSetId" : sampleSetId,
		"productType": `${DISCOVERY_PREFIX}${productType}`,
		"displayExtraMeanPercent" : displayExtraMeanPercent,
		"flipFoldChange" : invertedFoldChange
	});

export const fetchAndDownloadManifestTemplate = async (projectId) =>
	getBlob(urljoin(`${API_BASEPATH_PORTAL}`,'manifest', `file/download/${projectId}`), `ManifestTemplate.xlsx`);

